export default __webpack_public_path__ + "add-app-visual.png";